import { PropsWithChildren } from "react";
import { useUserContext } from "../../../context/user.context";
import PageLoader from "../../components/PageLoader/PageLoader";
import Forbidden from "../pages/Forbidden/Forbidden";

// Gates org-scoped admin screens (e.g. Organization Settings) behind org-admin-or-super-admin for
// the currently-selected org. Checks `loading` first so an org admin never sees a flash of
// Forbidden (or a non-admin a flash of admin content) while the user/org profile is still
// resolving - mirrors RequireSuperAdmin's pattern.
function RequireOrgAdmin({ children }: PropsWithChildren<{}>) {
  const { loading, orgOrSuperAdmin } = useUserContext();

  if (loading) {
    return <PageLoader />;
  }

  if (!orgOrSuperAdmin) {
    return <Forbidden />;
  }

  return <>{children}</>;
}

export default RequireOrgAdmin;
